import React from 'react';
import { Settings, FileText, Palette, Video, UserCheck } from 'lucide-react';

const WhiteGloveSupport = () => {
  const customizations = [
    { icon: FileText, text: 'Custom training and role-play development' },
    { icon: Settings, text: 'Industry-specific enablement paths' },
    { icon: Palette, text: 'White-labeled experiences' },
    { icon: Video, text: 'Professional media production for training content' },
    { icon: UserCheck, text: 'Dedicated onboarding and rollout support' }
  ];

  return (
    <section className="py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="p-8 md:p-12 rounded-3xl bg-gradient-to-br from-gray-900/90 to-indigo-900/30 border border-indigo-500/30">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white">
              Customization for <span className="text-indigo-400">Complex Organizations</span>
            </h2>
            <p className="text-lg text-gray-300">
              For enterprises requiring deeper support, Traain offers optional customization:
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
            {customizations.map((item, index) => {
              const Icon = item.icon;
              return (
                <div
                  key={index}
                  className={`flex items-center gap-4 p-5 rounded-xl bg-gray-900/50 border border-indigo-500/20 ${
                    index === 4 ? 'md:col-span-2 lg:col-span-1 lg:col-start-2' : ''
                  }`}
                >
                  <div className="w-10 h-10 bg-indigo-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Icon className="w-5 h-5 text-indigo-400" />
                  </div>
                  <p className="text-gray-300">{item.text}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhiteGloveSupport;
